export default __webpack_public_path__ + "static/media/BSC.f19e246f.svg";